var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "stopwatch_svg__svg30",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "stopwatch_svg__defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".stopwatch_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line8",
    d: "M10.525.503h2",
    className: "stopwatch_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line10",
    d: "M11.525.503v3",
    className: "stopwatch_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line12",
    d: "m19.525 3.503 1.5 1.5",
    className: "stopwatch_svg__a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line14",
    d: "m20.275 4.253-1.933 1.934",
    className: "stopwatch_svg__a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line16",
    d: "m6.525 8.503 1.5 1.5",
    className: "stopwatch_svg__a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line18",
    d: "M11.525 20.503v-2",
    className: "stopwatch_svg__a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line20",
    d: "m6.525 18.503 1.5-1.5",
    className: "stopwatch_svg__a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line22",
    d: "M18.525 13.503h-2",
    className: "stopwatch_svg__a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line24",
    d: "m16.525 18.503-1.5-1.5",
    className: "stopwatch_svg__a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__line26",
    d: "m16.525 8.503-1.5 1.5",
    className: "stopwatch_svg__a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "stopwatch_svg__path28",
    d: "M11.525 3.5v10h-10a10 10 0 1 0 10-10",
    className: "stopwatch_svg__a"
  })));
};
export default SvgStopwatch;